import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
  const skillGroups = [
    {
      label: 'Languages',
      skills: ['JavaScript', 'TypeScript', 'HTML/CSS', 'Python', 'SQL'],
    },
    {
      label: 'Frameworks',
      skills: ['Next.js', 'React', 'Node.js', 'Express.js', 'MUI', 'Tailwind CSS'],
    },
    {
      label: 'Developer Tools',
      skills: ['Git', 'Docker', 'Vercel', 'Firebase', 'CI/CD', 'Figma'],
    },
    {
      label: 'Databases & Services',
      skills: ['PostgreSQL', 'MongoDB', 'Prisma', 'Stripe', 'Cloudinary', 'Agora'],
    },
  ];

  // Waveform component
  const Waveform = () => (
    <div className="waveform">
      {[1, 2, 3, 4, 5].map((i) => (
        <motion.span
          key={i}
          animate={{ scaleY: [0.3, 1, 0.3] }}
          transition={{
            duration: 0.8,
            repeat: Infinity,
            delay: i * 0.1,
          }}
        />
      ))}
    </div>
  );

  return (
    <section id="about" className="about">
      <div className="about-container">
        {/* Section Header with Large Text */}
        <div className="about-header">
          <Waveform />
          <h2 className="about-title">
            Empowering ideas, <span className="dynamic">captivating</span>
            <br />
             <span className="teal">users</span>,            and building the future of

            <br />
            <span className="underline">web experiences</span>
            <br />
            as a <span className="dynamic">passionate</span> developer
          </h2>
        </div>

        {/* Two Column Layout */}
        <div className="about-grid">
          {/* Left - Bio */}
          <div className="about-bio">
            <span className="section-label">About Me</span>
            <p>
              I'm a frontend developer with a Computer Science degree from the Technical University of Cluj-Napoca. 
              I specialize in building modern web applications with Next.js, React, and TypeScript — from real-time 
              platforms powered by Firebase and Agora to full-stack e-commerce with Stripe and Prisma.
            </p>           
          </div>

          {/* Right - Skills */}
          <div className="about-skills">
            <span className="section-label">What I Work With</span>
            <div className="skills-groups">
              {skillGroups.map((group) => (
                <div key={group.label} className="skill-group">
                  <span className="skill-group-label">{group.label}</span>
                  <div className="skill-tags">
                    {group.skills.map((skill) => (
                      <motion.span
                        key={skill}
                        className="skill-tag"
                        whileHover={{ scale: 1.05, y: -2 }}
                        transition={{ type: 'spring', stiffness: 400 }}
                      >
                        {skill}
                      </motion.span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Marquee */}
        <div className="about-marquee">
          <div className="marquee-track">
            <div className="marquee-content">
              {['NEXT.JS', 'REACT', 'TYPESCRIPT', 'FIREBASE', 'STRIPE', 'PRISMA', 'NODE.JS', 'FIGMA', 'NEXT.JS', 'REACT', 'TYPESCRIPT', 'FIREBASE', 'STRIPE', 'PRISMA', 'NODE.JS', 'FIGMA'].map((item, i) => (
                <span key={i}>
                  {item}
                  <span className="dot">•</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
